import {format_date} from './utils'

export const riderToEditableList = (riders)=>{
    var output = []
    riders.forEach((rider)=>{
        console.log(rider);
        output.push({
            rider_name: rider.rider.first_name + " " + rider.rider.last_name,
            rider_team: rider.rider.resolved_team?rider.rider.resolved_team.team_name+" ("+rider.rider.resolved_team.team_code+")":"unknown",
            rider_id: rider.rider.rider_id,
            incident_rider_notes: rider.incident_rider_notes,
            incident_rider_implications: rider.incident_rider_implications,
            incident_rider_severity: rider.incident_rider_severity,
			incident_rider_card: rider.incident_rider_card,
			incident_rider_fault: rider.incident_rider_fault,
            incident_rider_injury: rider.incident_rider_injury
        })
    })
    return output
}

export const cleanUpNullValues = (object) =>{
    if (object === null || object === undefined) return object;
    if (object instanceof Date) return format_date(object);
    if (Array.isArray(object)) return object.map((value)=>{return cleanUpNullValues(value)});
    if (typeof object !== 'object') return object;

    var object_cpy = {...object};

    for(var key in object){
        if(object[key]===null || object[key]===undefined)
            delete object_cpy[key]
        else if(Array.isArray(object[key]))
            object_cpy[key] = object[key].map((value)=>{return cleanUpNullValues(value)})
        else if(object[key] instanceof Date)
            object_cpy[key] = format_date(object[key])
        else if(typeof object[key] === 'object')
            object_cpy[key] = cleanUpNullValues(object[key])
    }
    return object_cpy

}

export const buildIncidentPayload = (incident, options = {}) => {
    const { omitKeys = [] } = options;
    const payload = cleanUpNullValues(incident);
    omitKeys.forEach((key) => {
        delete payload[key];
    });
    return payload;
}

export const buildCreateIncidentPayload = (incident) => {
    const { allowMerge, ...payload } = buildIncidentPayload(incident);
    return { payload, allowMerge };
}
